// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '8aa42568-104d-4eb4-8159-69003428862e',
      type: 'Container',
      name: 'raySlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        opened: {
          visible: false
        }
      }
    },
    {
      id: 'cac7ec3e-12cd-4f8f-aadb-9568c1c3a9ac',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.39604,
        y: 0.39604
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        rotationCycle: 30000
      },
      stateByName: {
        opened: {
          visible: false
        }
      }
    },
    {
      id: '1acb8aaa-858f-4fe9-b0f1-f7accbf838bf',
      type: 'Sprite',
      name: 'chestShadow',
      className: '',
      x: 0,
      y: 2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.38,
        y: 0.38
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 12667504,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Chest_Gold_White',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        opened: {
          visible: false
        }
      }
    },
    {
      id: '7ea65fb9-bfe6-4a15-bf16-529f2286fa5d',
      type: 'Sprite',
      name: 'chest',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.38,
        y: 0.38
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -150,
        y: -125,
        width: 300,
        height: 250
      },
      texture: 'Chest_Gold',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        opened: {
          visible: false
        }
      }
    },
    {
      id: '9fb3e791-b6b8-4e94-8006-06b5cab8c5b2',
      type: 'Sprite',
      name: 'checkmark',
      className: '',
      x: 20,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Checked_Position_Dot',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        opened: {
          visible: true,
          angle: 0
        }
      }
    },
    {
      id: '2d76648c-0b08-4b72-8d12-607a08c56188',
      type: 'Container',
      name: 'rewardBubbleSlot',
      className: '',
      x: -8,
      y: 27,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'opened'
  ],
  animations: [
    {
      id: '918c76fa-1fd9-4e8f-8dae-f67ebfafc7a7',
      name: 'Chest_Open',
      playingSpeed: 1,
      totalDuration: 800,
      blocks: [
        {
          id: '944d0256-fa15-4544-b6b9-35a69ac64e94',
          type: 'Tween',
          name: 'squeeze1',
          duration: 100,
          track: 0,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a612224f-cf94-4d97-af34-ece5becdb3fb',
          type: 'Tween',
          name: 'squeeze2',
          duration: 200,
          track: 0,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 100,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '8c1e185c-0d03-4573-bbe8-295cf3c227ba',
          type: 'Tween',
          name: 'rotation1',
          duration: 300,
          track: 2,
          target: {
            angle: 10
          },
          startAt: 150,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f9bb8cc1-cf30-4c37-9a16-d21b6c508c46',
          type: 'Tween',
          name: 'translation1',
          duration: 300,
          track: 1,
          target: {
            y: -120
          },
          startAt: 150,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '80d0e49c-1884-456f-a66d-ace5068309ff',
          type: 'Tween',
          name: 'squeeze3',
          duration: 150,
          track: 0,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 300,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'af743554-6306-4c26-b57b-a3d983f4f2fa',
          type: 'Setter',
          name: 'ANIMEVENT_spawnGifts',
          track: 4,
          target: {},
          startAt: 450,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '4970f281-0011-4772-a043-74a94cb50ec4',
          type: 'Setter',
          name: 'ANIMEVENT_changeTexture',
          track: 3,
          target: {},
          startAt: 450,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '58cadfc2-20bd-4ec3-b547-f24b5d12d538',
          type: 'Tween',
          name: 'squeeze4',
          duration: 150,
          track: 0,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 450,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b0f24312-ec12-4eef-b605-a4609ee6ef59',
          type: 'Tween',
          name: 'rotation2',
          duration: 150,
          track: 2,
          target: {
            angle: 0
          },
          startAt: 470,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6cb9f9ac-b0ed-47b4-a7b0-a98f07315016',
          type: 'Tween',
          name: 'translation2',
          duration: 170,
          track: 1,
          target: {
            y: 0
          },
          startAt: 500,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7bf7ef73-17ad-4b76-b22a-45b21d67fbdd',
          type: 'Setter',
          name: 'FXPART_Race_Event_Particle_Behind_Chest_After_Opening',
          track: 5,
          target: {},
          startAt: 556,
          sourceName: 'particleSpawnPoint',
          disabled: false
        },
        {
          id: 'c8fedef1-d77f-4e90-83b9-f79f4c278765',
          type: 'Tween',
          name: 'squeeze5',
          duration: 100,
          track: 0,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 600,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '47e3c703-afe8-4c2d-bcf4-53cc3bc58998',
          type: 'Tween',
          name: 'squeeze6',
          duration: 100,
          track: 0,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 700,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class DioramaChestLayout {
  static raw = raw;
  root!: Container;
  raySlot!: Container;
  rays!: Sprite & { data: typeof raw['list'][2]['data'] };
  chestShadow!: Sprite;
  chest!: Sprite;
  checkmark!: Sprite;
  rewardBubbleSlot!: Container;
  rotate_SPL!: (Sprite & { data: typeof raw['list'][2]['data'] })[];
  StateName!: 'opened';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Chest_Open {
  Layout: {
    root: object;
    particleSpawnPoint: object;
  };

  BlockTypeByName: {
    squeeze1: object;
    squeeze2: object;
    rotation1: object;
    translation1: object;
    squeeze3: object;
    ANIMEVENT_spawnGifts: object;
    ANIMEVENT_changeTexture: object;
    squeeze4: object;
    rotation2: object;
    translation2: object;
    FXPART_Race_Event_Particle_Behind_Chest_After_Opening: object;
    squeeze5: object;
    squeeze6: object;
  };

  flowData = raw.animations[0];
}
